/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
*/

import qs from 'query-string'

import Request from 'generic/request/Request'

export const BENEFICIARY_NUMBER_URL = '/api/beneficiary/number/'
export const BENEFICIARY_NUMBER_TYPES_URL = '/api/beneficiary/number/type/list/?meta=false&objects_count=false'
export const BENEFICIARY_NUMBERS_URL = '/api/beneficiary/number/list/?meta=false&objects_count=false'

export function saveBeneficiaryNumber (beneficiaryNumber) {
  return Request.postRequest(BENEFICIARY_NUMBER_URL + (beneficiaryNumber.uid ? beneficiaryNumber.uid + '/' : ''), beneficiaryNumber)
    .then((result) => {
      return result.data.object
    })
}

export function getBeneficiaryNumber (beneficiary, numberType) {
  const query = {
    search: 'beneficiary_name:' + beneficiary.identities[0].first_name + ' ' + beneficiary.identities[0].last_name,
    number_type: numberType.uid
  }

  return Request.getRequest(BENEFICIARY_NUMBERS_URL + '&' + qs.stringify(query))
}



// WEBPACK FOOTER //
// ./src/actions/BeneficiaryNumber.js